import { useEffect } from "react";
import { applyTheme } from "../lib/theme";

// Staff app always uses the Showroom 360 Ink palette; the client's own colours stay on the public website.
export default function AdminThemeProvider({ children }) {
  useEffect(() => {
    applyTheme({ primary: "#23205C", secondary: "#23205C" });
    document.body.classList.add("staff-mode");
    return () => { document.body.classList.remove("staff-mode"); };
  }, []);
  return children;
}
